import type { CommunityGroup } from '@communities/community-groups/domain';
import { CardGrid } from '@core/components/CardGrid';
import { Card, Text } from '@soteria/design-system-ve';

import { CommunityGroupItem } from './CommunityGroupItem';
import * as styles from './CommunityGroupItemGrid.css';

export interface CommunityGroupItemGridProps {
  /**
   * List of community groups to display in the grid
   */
  communityGroups: CommunityGroup[];

  /**
   * Function called when a community group item is clicked
   */
  onGroupClick: (groupId: string) => void;

  /**
   * Whether to use auto-fit or auto-fill for grid columns
   * @default "auto-fit"
   */
  columnFit?: 'auto-fit' | 'auto-fill';

  /**
   * Gap between grid items
   * @default "medium"
   */
  gap?: 'small' | 'medium' | 'large';

  /**
   * Custom class name for the empty state message
   */
  emptyStateClassName?: string;
}

export function CommunityGroupItemGrid({
  columnFit = 'auto-fit',
  communityGroups,
  emptyStateClassName,
  gap = 'medium',
  onGroupClick,
}: CommunityGroupItemGridProps) {
  if (communityGroups.length === 0) {
    return (
      <Card elevation="low" padding="medium">
        <Text className={emptyStateClassName || styles.emptyState}>No community groups found.</Text>
      </Card>
    );
  }

  return (
    <CardGrid columns={columnFit} gap={gap}>
      {communityGroups.map(group => (
        <CommunityGroupItem key={group.id} communityGroup={group} onClick={() => onGroupClick(group.id)} />
      ))}
    </CardGrid>
  );
}
